export { default as SimpleFooter } from './SimpleFooter';
